import { createApp } from 'vue'
import __t from "../../../../helpers/translate";
import vue_helpers from "../../../../helpers/check_null";
import VueTheMask from 'vue-the-mask';
import {createBootstrap} from 'bootstrap-vue-next';
import user_profile from "./user_profile.vue";

window.U_PROFILE = createApp({
        name : "U_PROFILE",
        id : "U_PROFILE",
        components : {
            user_profile : user_profile,
        }
    })
    .mixin(__t)
    .mixin(vue_helpers)
    .use(createBootstrap())
    .use(VueTheMask)
    .use(v_store);

U_PROFILE.mount('#user_profile');